import { useStore } from "..";
export const useWebhook = () => useStore(({ webhook }) => webhook);
